import type { ICheckboxOption } from '@/creditflowresearch/ui/common/hooks/sidebar/useCheckboxFilter';
import { CorporateAdditionalFilter, type TCorporateAdditionalFilter } from '@/creditflowresearch/domain/vo/Bondscreener';

export const ADDITIONAL_FILTER_OPTIONS: ICheckboxOption<TCorporateAdditionalFilter>[] = [
  { value: CorporateAdditionalFilter.Debut, name: 'Debut' },
  { value: CorporateAdditionalFilter.Hybrid, name: 'Hybrid' },
  { value: CorporateAdditionalFilter.Retail, name: 'Retail' },
  { value: CorporateAdditionalFilter.ReOpenTap, name: 'Re-Open/Tap' },
  { value: CorporateAdditionalFilter.Upsized, name: 'Upsized' },
  { value: CorporateAdditionalFilter.Marketing, name: 'Marketing' },
];
